import { OrderId } from '@interfaces/order';

export const PATHS = {
  BASE_URL: '/api',
  ORDER: {
    base: '/order',
    orderDetail: (orderId: OrderId) => `/v1/order/pub/${orderId}`,
    depositConfirmed: (orderId: OrderId) =>
      `/order/${orderId}/deposit-confirmed`,
    uploadReceipts: (orderId: OrderId) => `/v1/order/${orderId}/receipt`,
    uploadCancellation: (orderId: OrderId) =>
      `/v1/order/pub/${orderId}/cancellation/file`,
    getReceiptsState: `/v2/receipt/pub/receipt-state`,
    retryRequisites: (orderId: OrderId) => `/v1/order/pub/${orderId}/retry`,
    getDeepLinks: (orderId: OrderId) => `/v1/order/pub/${orderId}/deep-links`,
    downloadReceipt: (receiptId: string) =>
      `/v1/receipt/pub/${receiptId}/download`,
  },
  FINGERPRINT: {
    uploadFingerprint: (orderId: OrderId) => `/order/${orderId}/fingerprint`,
  },
  IP: (orderId: OrderId) => `/v1/order/pub/${orderId}/ip`,
};
